import { useEffect } from 'react'

import { User } from '~/hooks/useAuthentication/types'

import { UserRole } from '~/__generated_types__/globalTypes'

const useAppcuesSetup = (user: User | null | undefined) => {
  useEffect(() => {
    if (!user || user.role !== UserRole.Customer) return

    if (!process.env.NEXT_PUBLIC_APPCUES_ACCOUNT_ID) {
      console.error('Call from layout: Appcues account ID is not set')

      return
    }

    if (typeof window === 'undefined' || !window.AppcuesReady) return

    window.AppcuesReady(() => {
      try {
        window.Appcues?.identify(user.uuid, {
          role: user.role,
          email: user.email,
          ...(user.role === UserRole.Customer &&
            user.customer && {
              customerName: user.customer.name,
              customerType: user.customer.type,
            }),
        })
      } catch (error) {
        console.error('Failed to initialize Appcues:', error)
      }
    })
  }, [user])
}

export default useAppcuesSetup
